import styled from '@emotion/styled';
import { device, useRevealTrail } from '@landsbankinn/ui';
import React from 'react';
import { CardHostLink } from '../../components/card/Card';
import { HorizontalHost } from '../../components/card/HorizontalCard';

export interface IProps {
  children: React.ReactNode;
  count?: number;
}

const Group = styled.div<{ count?: number }>`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  ${(props) =>
    props.count !== undefined && props.count % 3 === 2
      ? `
  :after{
    content: "";
    flex: 0.9;    
  }`
      : ``}
  > * {
    padding-bottom: 2em;
  }

  @media ${device.tablet} {
    margin-bottom: -20px;

    > ${CardHostLink} {
      width: calc((6 / 12 * 100%) - 15px);
      margin-bottom: 30px;
      padding-bottom: 0;
    }

    > ${HorizontalHost} {
      margin-bottom: 30px;
      padding-bottom: 0;
    }
  }

  @media ${device.desktop} {
    > ${CardHostLink} {
      width: calc((4 / 12 * 100%) - 15px);
      margin-bottom: 20px;
      padding-bottom: 0;
    }
    > ${HorizontalHost} {
      margin-bottom: 20px;
      padding-bottom: 0;
    }
  }
`;

export const ArticleCardGroup = ({ children, count }: IProps) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <Group ref={ref} count={count}>
      {itemsWithStyleProp}
    </Group>
  );
};
